import { render, staticRenderFns } from "./video.vue?vue&type=template&id=5e206875&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=5e206875&lang=scss&scoped=true&"
import style1 from "./video.vue?vue&type=style&index=1&id=5e206875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e206875",
  null
  
)

export default component.exports